<template>
  <PageLayout>
    <!-- Main Content -->
    <template #main>
      <ClientSelection  v-if="isMSMUser"
                        :disabled="appLoading"
                        @clientselectionchanged="onClientSelectionChanged"/>
      <PageHeaderSmall  class="my-2"
                        :title="$t('Webportal.SalesCockpit')"
                        :description="$t('Webportal.SalesCockpitDescription')"
                        @refresh="handleRefresh" />

      <DetailFilterRow  @filter-click="handleFilterClick"
                        @filter-changed="handleFilterChanged"
                        class="my-2" />
      <LegendList       class="my-3" />
      <!-- :legends="legendConfig" -->

      <CustomCard class="mt-4">
        <template #header-title>
          Sales Cockpit - Cluster
        </template>
        <template #header-subtitle>
          Overview of sales performance and key metrics.
        </template>
        <template #header-actions-top>
          <div>
            <BButton  variant="outline-secondary"
                      size="sm"
                      @click="handleExpandCollapseAll('salesPerformanceExpanded')">
            <ChevronsLeft v-if="salesPerformanceExpanded" :size="16" class="me-1" />
            <ChevronsRight v-else :size="16" class="me-1" />
            {{ salesPerformanceExpanded ? $t('Webportal.CollapseAll') : $t('Webportal.ExpandAll') }}
          </BButton>
          </div>
        </template>
        <template #header-actions-bottom>
          <BButton  variant="outline-secondary"
                    :disabled="true"
                    size="sm">
            <Save :size="16" class="me-2" />
            {{ $t('Webportal.SaveView') }}
          </BButton>

          <!-- Neue Komponente statt BFormSelect -->
          <SavedViewSelection
            v-model="selectedView"
                      :disabled="true"

            style="width: 300px;"
            :placeholder="$t('Webportal.ChangeView')"
            @create="handleCreateView"
          />
        </template>

        <KpiColumnBoard @toggle-column-expanded="handleColumnToggle"
                        :columns="columns" />
      </CustomCard>

       <!-- customized-card-noborder -->
      <CustomCard class="mt-4">
        <template #header-title>
          Sales Cockpit - KPI
        </template>
        <template #header-subtitle>
          Overview of sales performance and key metrics.
        </template>
        <template #header-actions-top>
          <div>
            <BButton  variant="outline-secondary"
                      size="sm"
                      @click="handleExpandCollapseAll('salesPerformanceKpiExpanded')">
            <ChevronsLeft v-if="salesPerformanceKpiExpanded" :size="16" class="me-1" />
            <ChevronsRight v-else :size="16" class="me-1" />
            {{ salesPerformanceKpiExpanded ? $t('Webportal.CollapseAll') : $t('Webportal.ExpandAll') }}
          </BButton>
          </div>
        </template>
        <KpiColumnBoard @toggle-column-expanded="handleColumnToggle"
                        :columns="kpiColumns" />
      </CustomCard>




    </template>
  </PageLayout>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import { gatherFilterIds } from '@/utils/treeHelpers';
import CancelToken from '@/mixins/CancelToken';
import DashboardService from '@/services/DashboardService-APP_TARGET';

import DetailFilterRow from '@/componentsv3/DetailFilterRow.vue';
import LegendList from '@/componentsv3/LegendList.vue';
import PageLayout from '@/componentsv3/PageLayout.vue';
import PageSidebar from '@/componentsv3/PageSidebar.vue';
import PageHeaderSmall from '@/componentsv3/PageHeaderSmall.vue';
import SeriesFilter from '@/componentsv3/SeriesFilter.vue';
import KpiColumnBoard from '@/componentsv3/KpiColumnBoard/KpiColumnBoard.vue';
import CustomCard from '@/componentsv3/CustomCard.vue';
import SavedViewSelection from '@/componentsv3/SavedViewSelection.vue';
import ClientSelection from '@/components/ClientSelection.vue';
import BrandFilterModal from '@/componentsv3/BrandFilterModal.vue';

import { ChevronsLeft, ChevronsRight, Save } from 'lucide-vue-next';

export default {
  name: 'SalesCockpit',
  mixins: [CancelToken],
  components: {
    BrandFilterModal,
    CustomCard,
    ClientSelection,
    DetailFilterRow,
    SeriesFilter,
    KpiColumnBoard,
    LegendList,
    PageHeaderSmall,
    PageLayout,
    PageSidebar,
    SavedViewSelection,

    ChevronsLeft, ChevronsRight, Save,
  },

  data() {
    return {
      columns: [],
      dashboardData: null,
      dashboardDataCancelToken: null,
      salesPerformanceExpanded: false,
      salesPerformanceKpiExpanded: false,
      selectedView: null,
      kpiColumns: [],
    }
  },

  computed: {
    ...mapGetters('auth', [ 'clientId', 'isMSMUser' ]),
    ...mapGetters('clientData', [ 'isClientReady', 'surveyIds', 'appLoading', 'filters', 'brandIds' ]),
    ...mapGetters('localization', [ 'currentLocalization', 'currentLocale' ]),
  },

  async mounted() {
    EventBus.$on('app.ready', this.loadOverviewData);
    if (this.isClientReady && this.filters && !this.dashboardData) {
      this.loadOverviewData();
    }
  },

  beforeUnmount() {
    EventBus.$off('app.ready', this.loadOverviewData);
  },


  methods: {
    ...mapActions('clientData', [ 'fetchFilters', 'setAppLoading' ]),

    getFilterSettings() {
      // const ww = this.filters?.waves;
      // const ww2= this.filters?.waves?.map(x => x.id).join(',');
      // log.warn("WAVES: ", ww, ww2);
      const filter = {
        api: APP_TARGET === 'bmw' ? 'bmw2021experimental' : undefined,
        brand: APP_TARGET === 'bmw' ? this.brandIds?.join('|') : undefined,
        client: this.clientId,
        waves: APP_TARGET === 'bmw' ? gatherFilterIds(this.filters?.Waves).join(',') : this.filters?.waves?.filter(x => x.checked).map(x => x.id).join(','),
        surveys: APP_TARGET === 'bmw' ? gatherFilterIds(this.filters?.Surveys).join(',') : this.filters?.surveys.filter(x => x.checked).map(x => x.id).join(','),
      };
      return filter;
    },

    async loadOverviewData() {
      this.setAppLoading(true);
      const filter = this.getFilterSettings();
      log.warn("S FLT: ", filter);
      this.dashboardDataCancelToken = this.initCancelToken(this.dashboardDataCancelToken);
      // await new Promise(resolve => setTimeout(resolve, 1000));
      await DashboardService.getDashboard(filter, this.dashboardDataCancelToken, this.currentLocale)
        .then(response => {
          log.warn("DATA: ", response?.data);
          this.dashboardData = response?.data;
          this.columns = this.getClusters();
          this.kpiColumns = this.getKpiColumns();
        })
        .catch(error => {
          log.error('FAIL:', error);
        }).finally(() => {
          this.setAppLoading(false);
        });
    },

    getClusters() {
      if (!this.dashboardData || !this.dashboardData.Question || !this.dashboardData.Cluster) {
        return [];
      }
      let columns = this.dashboardData.Cluster.filter(x => !x.Code.startsWith('0. ') ).map(g => {
        return {
          id: g.Code,
          label: g.Name,
          isExpanded: this.salesPerformanceExpanded,
          summary: {
            label: this.dashboardData.OverallByWave[0].Name,
            SurveyWave: this.dashboardData.OverallByWave[0].SurveyWave
          },
          SurveyWave: g.SurveyWave,
          waves: this.dashboardData.OverallByWave[0].SurveyWave,
          kpis: this.dashboardData.Question
            .filter(kpi => kpi.Code === g.Code)
            .map(kpi => ({
              id: kpi.Code,
              label: kpi.Name || kpi.QuestionText,
              SurveyWave: kpi.SurveyWave
            }))
        };
      });
      return columns;
    },

    getKpiColumns() {
      if (!this.dashboardData || !this.dashboardData.KPI || !this.dashboardData.KPIGroup) {
        return [];
      }
      let columns = this.dashboardData.KPIGroup.map(g => {
        return {
          id: APP_TARGET === 'bmw' ? g.KpiCode : g.Code,
          label: APP_TARGET === 'bmw' ? g.KpiName : g.Name,
          KpiCode:  APP_TARGET === 'bmw' ? g.KpiCode : g.Code,
          KpiName:  APP_TARGET === 'bmw' ? g.KpiName : g.Name,
          isExpanded: this.salesPerformanceExpanded,
          summary: {
            label: this.dashboardData.OverallByWave[0].Name,
            SurveyWave: this.dashboardData.OverallByWave[0].SurveyWave
          },
          SurveyWave: g.SurveyWave,
          YTD: g.YTD,
          waves: this.dashboardData.OverallByWave[0].SurveyWave,
          kpis: this.dashboardData.KPI
            .filter(kpi => kpi.GroupCode === g.KpiCode ||  kpi.GroupCode === g.Code)
            .map(kpi => ({
              id: APP_TARGET === 'bmw' ? kpi.KpiCode : kpi.Code,
              label: APP_TARGET === 'bmw' ? kpi.KpiName : kpi.Name,
              label: APP_TARGET === 'bmw' ? kpi.KpiName : kpi.Name,
              KpiCode: APP_TARGET === 'bmw' ? kpi.KpiCode : kpi.Code,
              GroupCode: kpi.GroupCode,
              KpiName: APP_TARGET === 'bmw' ? kpi.KpiName : kpi.Name,
              KpiNameShort: kpi.KpiNameShort,
              SurveyWave: kpi.SurveyWave,
              YTD: kpi.YTD
            }))
        };
      });

      return columns;
    },


    handleRefresh() {
      log.warn(this.filters);
      this.loadOverviewData();
    },

    async onClientSelectionChanged(clientSettings) {
      if (this.appLoading) return;
      log.warn("!!! FILTERS: ", clientSettings);
      // const data = await this.fetchFilters();
    },

    handleFilterChanged(filter, filters) {
      this.handleRefresh();
    },

    handleFilterClick(filter) {
      log.log('Filter clicked:', filter.key);
      // if (filter.key === 'brands') {
      //    this.showBrandModal = true;
      // }
      if (filter.key === 'refresh') {
        this.handleRefresh();
      }
    },

    handleColumnToggle(columnId) {
      const column = this.columns.find(c => c.id === columnId);
      if (column) {
        column.isExpanded = !column.isExpanded;
      }
    },
    handleExpandCollapseAll(switchName) {
      this[switchName] = !this[switchName];
      let collection = switchName === 'salesPerformanceExpanded' ? this.columns : this.kpiColumns;
      collection.forEach(column => {
        column.isExpanded = this[switchName];
      });
    },

    handleSeriesChange(selectedValues) {
      log.log('Ausgewählte Serien:', selectedValues);
      // API Call oder Filter anwenden
    },

    handleCreateView() {
      // filepath: c:\Users\lawi\Sandbox\loop_reporting_feb\frontend\src\pages\SalesCockpit.vue
      log.log('Neue Ansicht erstellen mit:', this.selectedView);
      // Logik zum Erstellen einer neuen Ansicht hier einfügen
    }
  }
}
</script>
